import React, { Component, useRef } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import image from "../../../../assets/img/svg/Image.svg"
import docIcon from "../../../../assets/img/svg/docIcon.svg"
import { TextField, InputBase, Radio, RadioGroup, InputAdornment, IconButton, FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery";
import Delete from '../../../../assets/img/svg/delete.svg';
import del from "../../../../assets/img/svg/Del.svg"
import axios from "axios";
import moment from "moment";
import API from "../../../../_helpers/endpointService";
const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& p': {
            marginLeft: "0px !important"
        }
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
}));

const CheckboxWithBlackCheck = withStyles({
    root: {
        "& .MuiSvgIcon-root": {
            fill: "#FFFFFF",
            width: 20,
            height: 20,
            border: "1px solid #000000",
            "&:hover": {
                backgroundColor: "#FFFFFF"
            }
        },
        "&$checked": {
            "& .MuiIconButton-label": {
                position: "relative",
                zIndex: 0,
                backgroundColor: "#FFFFFF",
            },
            "& .MuiIconButton-label:after": {
                content: '""',
                height: 10,
                width: 10,
                position: "absolute",
                backgroundColor: "#000000",
                zIndex: -1
            }
        }
    },
    checked: {}
})(Checkbox);

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

class AddIR extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.inputPhoto = React.createRef();
        this.state = {
            isMobile: false,
            cancel: false,
            check: false,
            files: [],
            photos: [],
            isError: false,
            radio: 'sample',
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Investigationtype": "",
                "Incidenttype": [],
                "Date": "",
                "Description": "",
                "ModifiedBy": ''
            },
            Error: {
                DateError: false,
                DescriptionError: false,
                IncidentTypeError: false,
                InvestigationTypeError: false,

            }
        }
    }
    handleChangeCheckbox = (event, name) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.state[name] = event.target.checked;
    };

    AttachFiles = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.inputFile.current.click();
    };
    AttachPhoto = (e) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true
        this.inputPhoto.current.click();
    };
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#INVES1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Investigation1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Investigation").removeClass("d-none");
        $("#Investigation").addClass("d-block");
        $("#IRL").addClass("active-color");
        $("#IRT").addClass("fw-bolder");
    };
    getSettingsFormat = (data) => {
        let apiUrl = API.SETTINGS_PROJECT + data;
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SETTINGS", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    componentDidMount() {
        this.getSettingsFormat(parseInt(localStorage.getItem("DashId")))
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);

    }
    componentWillUnmount() {
        clearInterval(this.interval);
        $("#INVES1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Investigation1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Investigation").addClass("d-none");
        $("#Investigation").removeClass("d-block");
        $("#IRL").removeClass("active-color");
        $("#IRT").removeClass("fw-bolder");
    }
    handleRadio = (event) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.radio = event.target.value
        this.setState({})
    };
    handleInputChange = (e, str) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        if (str === "Description") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData.Description = e.target.value;
            }
        } else {
            this.state.addData[str] = e.target.value;
        }
        this.setState({})
    };
    setCheckbox = (str) => {
        this.state.files.map((i) => {
            if (str == i.fileName) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };
    setCheckbox1 = (str) => {
        this.state.photos.map((i) => {
            if (str == i.fileName) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };
    UploadFile = (e) => {
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                fileName: a.name,
                size: a.size,
                check: false,
                fdata: a,
            }
            this.state.files.push(upload)
            this.setState({})
        })
    };
    UploadPhoto = (e) => {
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                fileName: a.name,
                size: a.size,
                check: false,
                fdata: a,
                base64: await this.toBase64(a),
            }
            this.state.photos.push(upload)
            this.setState({})
        })
    };
    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/investigationreports`)
        }
    }
    AddCancel = () => {
        window.$("#cancelpopup").modal("hide");
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/investigationreports")
    };
    OpenPopup = (i) => {
        this.state.delindex = i;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }
    DeleteItem = () => {
        let tempData = [];
        this.state.files.map((i, a) => {
            if (a != this.state.delindex) {
                tempData.push(i)
            }
        })
        this.state.files = tempData;
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }
    OpenPopup1 = (i) => {
        this.state.delindex1 = i;
        this.setState({})
        window.$("#deletepopup1").modal("show");
    }
    DeleteItem1 = () => {
        let tempData = [];
        this.state.photos.map((i, a) => {
            if (a != this.state.delindex1) {
                tempData.push(i)
            }
        })
        this.state.photos = tempData;
        this.setState({})
        window.$("#deletepopup1").modal("hide");
    }
    handleChange = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        if (e.target.checked == false) {
            if (this.state.addData.Incidenttype.length > 0) {
                this.state.addData.Incidenttype.map((i, ind) => {
                    if (i == e.target.value) {
                        this.state.addData.Incidenttype.splice(ind, 1)
                        this.setState({})
                    }
                })
            }
        }
        else {
            this.state.addData.Incidenttype.push(e.target.value)
            this.setState({})
        }
    }
    AddSave = () => {
        if (this.state.addData.Date == "") {
            this.state.Error.DateError = true;
            this.setState({})
        }
        else {
            this.state.Error.DateError = false;
            this.setState({})
        }
        if (this.state.addData.Investigationtype == '') {
            this.state.Error.InvestigationTypeError = true;
            this.setState({})
        }
        else {
            this.state.Error.InvestigationTypeError = false;
            this.setState({})
        }
        if (this.state.addData.Incidenttype == "") {
            this.state.Error.IncidentTypeError = true;
            this.setState({})
        }
        else {
            this.state.Error.IncidentTypeError = false;
            this.setState({})
        }
        if (this.state.addData.Description == "") {
            this.state.Error.DescriptionError = true;
            this.setState({})
        }
        else {
            this.state.Error.DescriptionError = false;
            this.setState({})
        }
        if (this.state.addData.Date != '' && this.state.addData.Incidenttype != '' && this.state.addData.Investigationtype != '' && this.state.addData.Description != "") {
            this.props.dispatch({ type: "CANCEL", data: false });
            let formData = new FormData()
            if (this.state.addData.Description.trim() != "") {
                this.state.addData.Description = this.state.addData.Description.trim();
                this.setState({})
            }
            else {
                this.state.addData.Description = this.state.addData.Description.trim();
                this.setState({})
            }
            Array.from(this.state.files).forEach(async (a) => {
                formData.append("documents", a.fdata)

            })
            Array.from(this.state.photos).forEach(async (a) => {
                formData.append("photos", a.fdata)

            })
            this.addIR(this.state.addData, formData)
        }
    }
    addIR = (data, formData) => {
        let apiUrl = API.IR_LISTVIEW;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.adduploadirdocinfo(formData, response.data)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    }
    adduploadirdocinfo = (data, id) => {
        let apiUrl = API.IR_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/investigationreports")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    }
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100  mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"INVES" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="INVES" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>Add New Investigation Report</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.AddSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                </td>
                                <td className="text-center">
                                    <button className={classes.button} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        :
                        <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td width="95%">
                                        <button className={classes.button} onClick={this.AddSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button} `} style={{ minWidth: '70px' }} onClick={this.AddCancel1} ><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" :
                            <h6 className="col-12 mx-2 mt-3 ml-1">Add New Investigation Report</h6>}
                        <div className={this.state.isMobile ? "row mt-1 mx-0 pr-2 pt-1" : "row mt-1 mx-3 pr-2 pt-1"}>
                            <div className={`row mt-2 mx-1 align-items-center  ${this.state.isMobile ? "" : "text-row"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "m-0 d-flex text-right"}>Investigation Type&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 col-xl-7  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 col-lg-12 pt-1 pb-2" : "col-lg-10 col-md-10 pt-4 pb-3"}`}>
                                    {this.state.Error.InvestigationTypeError ?
                                        <>
                                            <RadioGroup row aria-label="gender" value={this.state.addData.Investigationtype} onChange={(e) => { this.handleInputChange(e, "Investigationtype") }} fullWidth className={classes.error}>
                                                <FormControlLabel value="NearMiss" control={<Radio color="default" className={classes.error} />} label="Near Miss" size="small" />
                                                <FormControlLabel value="Incident" control={<Radio color="default" className={classes.error} />} label="Incident" size="small" />
                                            </RadioGroup>
                                        </>
                                        :
                                        <RadioGroup row aria-label="gender" value={this.state.addData.Investigationtype} onChange={(e) => { this.handleInputChange(e, "Investigationtype") }} fullWidth>
                                            <FormControlLabel value="NearMiss" control={<Radio color="default" />} label="Near Miss" size="small" />
                                            <FormControlLabel value="Incident" control={<Radio color="default" />} label="Incident" size="small" />
                                        </RadioGroup>}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "m-0 d-flex text-right float-end"}>Date&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {this.state.Error.DateError ?
                                        <TextField
                                            type="date"
                                            id="type-date"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "Date") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            inputProps={{
                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                              }}
                                        />
                                        :
                                        <TextField
                                            type="date"
                                            id="type-date"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "Date") }}
                                            inputProps={{
                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                              }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "m-0 d-flex text-right float-end"}>Incident Type&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                    {this.state.Error.IncidentTypeError ?
                                        <div className="row " style={{}}>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Fatalities" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Fatalities</div>
                                            </div>
                                            <div className=" pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="LTI" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>LTI</div>
                                            </div>
                                            <div className=" pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="RWC" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>RWC</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="FAC" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>FAC</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="MTC" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>MTC</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Property Damage" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Property Damage</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Oil Spill" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Oil Spill</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Chemical Spill" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Chemical Spill</div>
                                            </div>
                                            <div className=" pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Gas Leakage" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Gas Leakage</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Environmental Damage" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Environmental Damage</div>
                                            </div>
                                        </div>
                                        :
                                        <>
                                            <div className="row" style={{}}>
                                                <div className="pb-4 col-sm-3 d-flex">
                                                    <label class="contCheck">
                                                        <input type="checkbox" value="Fatalities" onChange={(e) => this.handleChange(e)}></input>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <div className="ml-5">Fatalities</div>
                                                </div>
                                                <div className=" pb-4 col-sm-3 d-flex">
                                                    <label class="contCheck">
                                                        <input type="checkbox" value="LTI" onChange={(e) => this.handleChange(e)}></input>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <div className="ml-5">LTI</div>
                                                </div>
                                                <div className=" pb-4 col-sm-3 d-flex">
                                                    <label class="contCheck">
                                                        <input type="checkbox" value="RWC" onChange={(e) => this.handleChange(e)}></input>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <div className="ml-5">RWC</div>
                                                </div>
                                                <div className="pb-4 col-sm-3 d-flex">
                                                    <label class="contCheck">
                                                        <input type="checkbox" value="FAC" onChange={(e) => this.handleChange(e)}></input>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <div className="ml-5">FAC</div>
                                                </div>
                                                <div className="pb-4 col-sm-3 d-flex">
                                                    <label class="contCheck">
                                                        <input type="checkbox" value="MTC" onChange={(e) => this.handleChange(e)}></input>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <div className="ml-5">MTC</div>
                                                </div>
                                                <div className="pb-4 col-sm-3 d-flex">
                                                    <label class="contCheck">
                                                        <input type="checkbox" value="Property Damage" onChange={(e) => this.handleChange(e)}></input>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <div className="ml-5">Property Damage</div>
                                                </div>
                                                <div className="pb-4 col-sm-3 d-flex">
                                                    <label class="contCheck">
                                                        <input type="checkbox" value="Oil Spill" onChange={(e) => this.handleChange(e)}></input>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <div className="ml-5">Oil Spill</div>
                                                </div>
                                                <div className="pb-4 col-sm-3 d-flex">
                                                    <label class="contCheck">
                                                        <input type="checkbox" value="Chemical Spill" onChange={(e) => this.handleChange(e)}></input>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <div className="ml-5">Chemical Spill</div>
                                                </div>
                                                <div className=" pb-4 col-sm-3 d-flex">
                                                    <label class="contCheck">
                                                        <input type="checkbox" value="Gas Leakage" onChange={(e) => this.handleChange(e)}></input>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <div className="ml-5">Gas Leakage</div>
                                                </div>
                                                <div className="pb-4 col-sm-3 d-flex">
                                                    <label class="contCheck">
                                                        <input type="checkbox" value="Environmental Damage" onChange={(e) => this.handleChange(e)}></input>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <div className="ml-5">Environmental Damage</div>
                                                </div>
                                            </div>
                                        </>}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "m-0 d-flex text-right float-end"}>Description&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                    {this.state.Error.DescriptionError ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            multiline
                                            value={this.state.addData.Description}
                                            onChange={(e) => { this.handleInputChange(e, "Description") }}
                                            rows={4}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            value={this.state.addData.Description}
                                            onChange={(e) => { this.handleInputChange(e, "Description") }}
                                            rows={4}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Description?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Description?.length}/500 Characters left</label>
                                </div>
                            </div>
                            <div className={`row mx-1  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2"}`}>
                                    <label className={this.state.isMobile ? " pt-2" : "m-0 d-flex text-right float-end pt-4 mt-2"}>Documents&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right  col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        disabled
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        accept=".pdf"
                                        onChange={(e) => { this.UploadFile(e) }}
                                        placeholder="Browse File"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className="mr-0">
                                                    <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                    <input
                                        hidden
                                        multiple="multiple"
                                        accept=".pdf"
                                        onChange={(e) => { this.UploadFile(e) }}
                                        type="file"
                                        ref={this.inputFile}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-md-6 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                    <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                        {this.state.files && this.state.files.map((m, i) => (
                                            <div className={`col-6 col-lg-4 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${window.innerWidth < 360 ? "col-12" : this.state.isMobile ? "col-md-4 col-sm-4" : "col-md-6 col-sm-6"}`}>
                                                <div className="row d-flex pr-3">
                                                    <div className="col-10 col-sm-10 col-lg-10 col-xl-10 col-md-10">
                                                        <div className="pt-2 overflow">{m.fileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(m.size / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                    </div>
                                                    <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pl-1 mt-2 pt-1 pr-2">
                                                        <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i) }} />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className={`row mx-1  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2"}`}>
                                    <label className={this.state.isMobile ? " pt-2" : "m-0 d-flex text-right float-end pt-4 mt-2"}>Photos&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right  col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        disabled
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onChange={(e) => this.UploadPhoto(e)}
                                        accept=".png,.jpg"
                                        placeholder="Browse File"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className="mr-0">
                                                    <IconButton className="rotate p-0" onClick={this.AttachPhoto}>
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                    <input
                                        hidden
                                        type="file"
                                        multiple="multiple"
                                        onChange={(e) => this.UploadPhoto(e)}
                                        accept=".png,.jpg"
                                        ref={this.inputPhoto}
                                    />
                                </div>
                                <div className="col-12 col-sm-12 col-lg-6 col-xl-8"></div>
                                <div className="row mx-0 px-0">
                                    <div
                                        className={`col-12 col-sm-12  col-md-12 col-lg-12 col-xl-12 align-items-center ${this.state.isMobile
                                                ? "border-left border-right border-bottom col-md-12"
                                                : "mt-2 "
                                            }`}
                                    >
                                        <div
                                            className={
                                                this.state.isMobile ? "row pl-2 pr-3" : "row px-1"
                                            }
                                        >
                                            {this.state.photos &&
                                                this.state.photos.map((i, ind) => {
                                                    return (
                                                        <div
                                                            className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center px-1 mt-2 mb-2 ${window.innerWidth < 410
                                                                    ? "col-12"
                                                                    : this.state.isMobile
                                                                        ? "col-md-4 "
                                                                        : "col-md-6"
                                                                }`}
                                                        >
                                                            <div className="row d-flex">
                                                                <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9"></div>
                                                                <div className="col-3 col-sm-3 col-lg-3 col-xl-3 col-md-3 ">
                                                                    <img
                                                                        src={Delete}
                                                                        className="cursorPointer"
                                                                        onClick={() => { this.OpenPopup1(ind) }}
                                                                    />
                                                                </div>
                                                                <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-3 px-2">
                                                                    <img
                                                                        src={i.base64}
                                                                        width={window.innerWidth < 290 ? "100%" : "257px"}
                                                                        style={{
                                                                            height: "201px",
                                                                            marginTop: "-9px",
                                                                            objectPosition: "50% 50%",
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </div>
                                {/* <div className={`col-12 col-sm-12  col-md-12 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                    <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                        {this.state.photos && this.state.photos.map((i, ind) => {
                                            return (
                                                <div className={`col-6 col-sm-4 col-lg-6 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${window.innerWidth < 410 ? "col-12" : this.state.isMobile ? "col-md-4" : "col-md-6"}`}>
                                                    <div className="row d-flex">
                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3">
                                                            <img src={i.base64} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                        </div>
                                                        <div className="col-8 col-sm-8 col-lg-8 col-xl-8 col-md-8">
                                                            <div className="overflow pt-2 ml-3">{i.fileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.size / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                        </div>
                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pl-1 pr-2 mt-2 pt-2">
                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup1(ind) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" id="closemodal1" onClick={() => window.$("#deletepopup").modal("hide")} class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem1()}><span className="" >Delete</span></button>
                                <button type="button" id="closemodal" onClick={() => window.$("#deletepopup1").modal("hide")} class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
        // projectList: state.projectReducer.projectList || [],
        // projectNames: state.projectReducer.projectNames || [],
    };
}

AddIR.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddIR))
); 